import { useState } from "react";

import { PatientPnrPage } from "./PatientPnrPage";
import { CameraInputPage } from "./CameraInputPage";

import "./index.scss";

const Page = () => {
  const [activePatientPnr, setActivePatientPnr] = useState<string | null>(null);
  return activePatientPnr === null ? (
    <PatientPnrPage onEnter={(pnr) => setActivePatientPnr(pnr)} />
  ) : (
    <CameraInputPage onExit={() => setActivePatientPnr(null)} pnr={activePatientPnr} />
  );
};

export default Page;
